// The content is collapsed with max-height, so the open height has to be
// measured before every transition — the text reflows with the viewport.
function setAccordionHeight(content, height) {
  content.style.maxHeight = height;
}

function openAccordionItem(item) {
  const content = item.querySelector('.reviews-accordions-item-content');
  const titleContainer = item.querySelector('.reviews-accordions-item-title-container');

  if (!content) return;

  function onOpened(event) {
    if (event.propertyName !== 'max-height') return;

    content.removeEventListener('transitionend', onOpened);
    // dropping the fixed height lets the open item follow later reflows
    setAccordionHeight(content, 'none');
  }

  item.classList.add('active');
  if (titleContainer) titleContainer.setAttribute('aria-expanded', 'true');

  content.addEventListener('transitionend', onOpened);
  setAccordionHeight(content, `${content.scrollHeight}px`);
}

function closeAccordionItem(item) {
  const content = item.querySelector('.reviews-accordions-item-content');
  const titleContainer = item.querySelector('.reviews-accordions-item-title-container');

  if (!content) return;

  item.classList.remove('active');
  if (titleContainer) titleContainer.setAttribute('aria-expanded', 'false');

  // an open item sits at max-height: none, which cannot be transitioned from,
  // so pin it to its current height first and collapse on the next frame
  setAccordionHeight(content, `${content.scrollHeight}px`);

  requestAnimationFrame(function () {
    setAccordionHeight(content, '0px');
  });
}

function toggleAccordionItem(item) {
  if (item.classList.contains('active')) {
    closeAccordionItem(item);
  } else {
    openAccordionItem(item);
  }
}

function initReviewsAccordions(root) {
  root.querySelectorAll('.reviews-accordions-item').forEach(function (item) {
    if (item.dataset.reviewsAccordionReady === 'true') return;

    const titleContainer = item.querySelector('.reviews-accordions-item-title-container');

    if (!titleContainer) return;

    item.dataset.reviewsAccordionReady = 'true';

    titleContainer.setAttribute('role', 'button');
    titleContainer.setAttribute('tabindex', '0');
    titleContainer.setAttribute('aria-expanded', 'false');

    titleContainer.addEventListener('click', function () {
      toggleAccordionItem(item);
    });

    titleContainer.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();
      toggleAccordionItem(item);
    });
  });
}

function runReviewsAccordions() {
  initReviewsAccordions(document);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runReviewsAccordions);
} else {
  runReviewsAccordions();
}

document.addEventListener('shopify:section:load', function (event) {
  initReviewsAccordions(event.target);
});
